import React from "react";
import QRCode from "react-qr-code";

const QRCodeGenerator = ({ value, size = 80, bgColor = "#ffffff", fgColor = "#000000" }) => {
  if (!value) {
    return <p style={{ color: "red" }}>QR Code value is required</p>;
  }
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: 0 }}>
      <QRCode
        value={value}
        size={size}
        bgColor={bgColor}
        fgColor={fgColor}
        style={{
          width: size,
          height: size,
          padding: 0,
          margin: 0,
          backgroundColor: bgColor,
        }}
      />
    </div>
  );
};

export default QRCodeGenerator;
